import * as PIXI from "pixi.js";


export function drawArc(arc: PIXI.Graphics, r: number, sRadian: number, eRadian: number, w: number, color: number, cClockwise: boolean, isStroke: boolean) {
  arc.clear();
  if (!isStroke) {
    arc
      .arc(0, 0, r, sRadian, eRadian, cClockwise)
      .stroke({ width: w, color });
  } else {
    arc
      .moveTo(Math.cos(sRadian) * r, Math.sin(sRadian) * r)
      .lineTo(0, 0)
      .arc(0, 0, r, sRadian, eRadian, cClockwise)
      .moveTo(0, 0)
      .lineTo(Math.cos(eRadian) * r, Math.sin(eRadian) * r)
      .stroke({ width: w, color })
  }
  arc.rotation = 0;
}

export function drawSquare(square: PIXI.Graphics, dim: number, startRadian: number, endRadian: number, color: number, cClockwise: boolean) {
  square.clear();
  square.rect(0, 0, dim, dim)
    .fill(color)
    .stroke({ color: 0x000000, width: 3 })
  square.rotation = !cClockwise ? startRadian : endRadian;
}